import { Button, Spin } from "antd";
import { MaterialCiqIcon, SubmittalCiqIcon } from "components/svg-icons";
import {
  FilterNamesEnum,
  GcDashBoardType,
  NavigationPageEnum
} from "../../models";

function NoPlanMessageBox({
  title,
  text,
  linkButton,
  buttonData
}: {
  title: string;
  text: any;
  linkButton: any;
  buttonData: any;
}) {
  return (
    <div className="p-2 pb-6 flex flex-col space-y-2 w-full items-center box-border">
      <div className="flex justify-between items-center w-full px-2">
        <div className="box-header !text-sm">{title}</div>
        {linkButton}
      </div>

      <div className="flex w-full items-center px-4 space-x-4">
        <div className="flex flex-wrap">{buttonData}</div>

        <div>{text}</div>
      </div>
    </div>
  );
}

function PlanningDataQualityReport({
  dashboardData,
  goToFiltered
}: {
  dashboardData: GcDashBoardType | undefined;
  goToFiltered: (page: NavigationPageEnum, filter: FilterNamesEnum) => void;
}) {
  return (
    <div className="box-border w-full">
      <div className="box-header bottom-border !p-6">Planning Due</div>

      {dashboardData ? (
        <div className="flex flex-col space-y-6 p-6">
          {dashboardData?.submittals?.submittals_with_no_planned_dates === 0 &&
            dashboardData?.materials?.materials_with_no_planned_dates === 0 && (
              <div className="flex h-40 items-center p-2 justify-center text-xs">
                <div>
                  There are no submittals and materials which require planning.
                </div>
              </div>
            )}
          {dashboardData?.submittals?.submittals_with_no_planned_dates ? (
            <NoPlanMessageBox
              title="Submittals"
              text="Link these Submittals to start planning and tracking."
              linkButton={
                <Button
                  type="link"
                  className="p-0 h-fit px-1"
                  onClick={() => {
                    goToFiltered(
                      NavigationPageEnum.SubmittalLog,
                      FilterNamesEnum.NoPlan
                    );
                  }}
                  data-testid="index-button-create-plan-snpd"
                >
                  Create Plan
                </Button>
              }
              buttonData={
                <div className="flex items-center space-x-1 border border-solid border-ciq-primary-900-light px-2 py-0.5 bg-ciq-primary-900-light bg-opacity-30 rounded-sm">
                  <SubmittalCiqIcon size={14} />
                  <div className="max-w-xs min-w-[20px]">
                    {
                      dashboardData?.submittals
                        ?.submittals_with_no_planned_dates
                    }
                  </div>
                </div>
              }
              data-testid="no-plan-message-box-snpd"
            />
          ) : null}
          {dashboardData?.materials?.materials_with_no_planned_dates ? (
            <NoPlanMessageBox
              title="Materials"
              text="Link these Materials to start planning and tracking."
              linkButton={
                <Button
                  type="link"
                  className="p-0 h-fit px-1"
                  onClick={() => {
                    goToFiltered(
                      NavigationPageEnum.MaterialLog,
                      FilterNamesEnum.NoPlan
                    );
                  }}
                  data-testid="index-button-create-plan-mnpd"
                >
                  Create Plan
                </Button>
              }
              buttonData={
                <div className="flex items-center space-x-1 border border-solid border-ciq-blue-cyan px-2 py-0.5 bg-ciq-blue-cyan bg-opacity-30 rounded-sm">
                  <MaterialCiqIcon size={14} />
                  <div className="max-w-xs min-w-[20px]">
                    {dashboardData.materials.materials_with_no_planned_dates}
                  </div>
                </div>
              }
              data-testid="no-plan-message-box-mnpd"
            />
          ) : null}

          {dashboardData?.materials?.materials_linked_with_voided_submittals ? (
            <NoPlanMessageBox
              title="Materials linked with Void Submittal"
              text="Link these Materials to start planning and tracking."
              linkButton={
                <Button
                  type="link"
                  className="p-0 h-fit px-1"
                  onClick={() => {
                    goToFiltered(
                      NavigationPageEnum.MaterialLog,
                      FilterNamesEnum.IsLinkedVoidSubmittal
                    );
                  }}
                  data-testid="index-button-create-plan-mlwvs"
                >
                  Create Plan
                </Button>
              }
              buttonData={
                <div className="flex items-center space-x-1 border border-solid border-ciq-blue-cyan px-2 p-1 bg-ciq-blue-cyan bg-opacity-30 rounded-sm">
                  <MaterialCiqIcon size={14} />
                  <div className="max-w-xs min-w-[20px]">
                    {
                      dashboardData.materials
                        .materials_linked_with_voided_submittals
                    }
                  </div>
                </div>
              }
              data-testid="no-plan-message-box-mlwvs"
            />
          ) : null}
        </div>
      ) : (
        <div className="w-full h-40 flex items-center justify-center">
          <Spin />
        </div>
      )}
    </div>
  );
}
export default PlanningDataQualityReport;
